import { skipToken } from '@reduxjs/toolkit/dist/query'
import { SelectField } from 'components/Inputs/Inputs'
import { TableActions } from 'components/TableActions/TableActions'
import { Table } from 'components/TableComponents/Table'
import { useEffect, useState } from 'react'
import { Field } from 'react-final-form'
import closeImage from 'assets/images/close.png'
import { useGetTravelDetailsByIdQuery, useShowAllFlightCompaniesQuery } from 'redux/store/actions'
import { useParams } from 'react-router-dom'

export const FlightCompanyField = (props: any) => {
  const {
    field,
    fields,
    index,
    mode,
    choosenFlights,
    setChoosenFlights,
    setDeletedFlights,
    deletedFlights,
  } = props
  const [flightCompany, setFlightCompany] = useState<any>()
  const [choosenCompany, setChoosenCompany] = useState<any>()
  const { data: flightCompaniesRows } = useGetTravelDetailsByIdQuery(flightCompany || skipToken)
  const { data: flightCompanies } = useShowAllFlightCompaniesQuery({})
  const params = useParams()
  const tableHeaders = [
    {
      title: '',
      width: '',
      renderCell: (row: any) => {
        return (
          <input
            type="radio"
            name={`${row.Id}`}
            // checked={choosenFlights.map((item: any) => item.FlightTravelId).includes(row.Id)}
            checked={choosenCompany?.FlightTravelId === row.Id}
            onChange={e => {
              if (e.target.checked) {
                setChoosenCompany({
                  index,
                  FlightTravelId: row.Id,
                })
              }
            }}
          />
        )
      },
    },
    {
      title: 'From',
      width: '',
      renderCell: (row: any) => {
        return `${row.FromCityName}-${row.FromCountryName}`
      },
    },
    {
      title: 'To',
      width: '',
      renderCell: (row: any) => {
        return `${row.ToCityName}-${row.ToCountryName}`
      },
    },
    {
      title: 'Departure',
      width: '',
      renderCell: (row: any) => {
        return row.DepartureDateTime.split('T')[0]
      },
    },
    {
      title: 'Arrival',
      width: '',
      renderCell: (row: any) => {
        return row.ArrivalDateTime.split('T')[0]
      },
    },
  ]

  useEffect(() => {
    if (choosenCompany) {
      if (choosenFlights && choosenFlights.length > 0) {
        const existItem = choosenFlights.find(
          (item: any) => +item.FlightTravelId === +choosenCompany.FlightTravelId
        )
        if (!existItem) {
          if (choosenCompany?.FlightTravelId && choosenFlights[index]?.FlightTravelId) {
            // Create a new array with the updated flight
            const updatedFlights = choosenFlights.map((flight: any, i: number) => {
              if (i === index) {
                return { ...flight, FlightTravelId: choosenCompany.FlightTravelId }
              }
              return flight
            })
            setChoosenFlights(updatedFlights)
          } else if (choosenCompany?.FlightTravelId) {
            setChoosenFlights([...choosenFlights, choosenCompany])
          }
        }
      } else {
        setChoosenFlights([choosenCompany])
      }
    }
  }, [choosenCompany])
  useEffect(() => {
    if (props.packageDataById) {
      setFlightCompany(props.packageDataById?.Items?.packageFlights[index]?.FlightCompanyId)
      setChoosenCompany({
        FlightTravelId: props.packageDataById?.Items?.packageFlights[index]?.FlightTravelId,
        index,
      })
    }
  }, [props.packageDataById])
  useEffect(() => {
    if (deletedFlights.length > 0) {
      setFlightCompany(choosenFlights[index]?.FlightCompanyId)
      setChoosenCompany({
        FlightTravelId: choosenFlights[index]?.FlightTravelId,
        index,
      })
    }
  }, [deletedFlights])

  return (
    <div className="w-full flex flex-wrap p-1 relative pb-10" key={fields.value[index].id}>
      <button
        type="button"
        onClick={() => {
          const haveId = fields.value[index].Id
          const deletedId = fields.value[index]
          const deletedItem = { ...deletedId, IsDeleted: true }
          fields.remove(index)
          if (haveId) {
            const newChoosenFlights = choosenFlights.filter((item: any) => +item.Id !== +haveId)
            setDeletedFlights((prev: any) => [...deletedFlights, deletedItem])
            setChoosenFlights(newChoosenFlights)
          }
        }}
        className=" absolute rtl:left-2 rtl:right-auto ltr:right-2 bottom-1 bg-[#FCE5E5] right-2 text-red-600 text-lg w-8 h-8 text-center rounded-xl">
        <img src={closeImage} alt="close" className="m-auto" />
      </button>
      <div className="w-full flex flex-col p-1">
        <div className="w-1/5 ">
          <Field
            label="Flight Company"
            name={`${field}.FlightCompanyId`}
            render={SelectField}
            options={flightCompanies?.data?.Items || []}
            valueField="Id"
            disabled={mode === 'view'}
            onChange={(e: any) => {
              setFlightCompany(e)
            }}
            textField="Name"
          />
        </div>
      </div>
      <div className="w-full">
        <TableActions endPoint="package" headers={tableHeaders} />
        <Table
          elements={flightCompaniesRows?.data?.Travels || []}
          height="150px"
          tableHeaders={tableHeaders}
        />
      </div>
    </div>
  )
}
